import {handleActions, combineActions} from 'redux-actions';
import * as directory from '../../actions/directory';
import {
  IDirectorySearchResponse,
  //   IArticle,
  //   IArticlesData,
  //   // , ICity
} from '../../../interfaces/directory';
export interface directoryStateType {
  // cities: {error: boolean; data: Array<ICity>};
  //articles: {error: boolean; data: Array<IArticle>};
  directoryData: {error: boolean; data: IDirectorySearchResponse};
  //businessProfileData: {error: boolean; data: IBusinessPage};
}

const initialState = {
  // cities: {error: false, data: null},
  directoryData: {error: false, data: null},
  //businessProfileData: {error: false, data: null},
  //articlesData: {error: false, data: null},
};

const handlerMap = new Map([
  // [
  //   combineActions(cityGuides.getCitiesSuccess, cityGuides.getCitiesFailure),
  //   (state, {payload}) => {
  //     return {
  //       ...state,
  //       cities: payload,
  //     };
  //   },
  // ],
  [
    combineActions(directory.getDirectorySuccess, directory.getDirectoryFailure),
    (state, {payload}) => {
      return {
        ...state,
        directoryData: payload,
      };
    },
  ],
]);

export default handleActions(handlerMap, initialState);
